import { MenuItem } from '../../ui/dtos/menu-item';
import { faClipboardList, faGifts, faFileExport, faChartDiagram, faFileCircleCheck, faLocationDot, faReceipt, faGaugeHigh } from '@fortawesome/free-solid-svg-icons';
import { core } from '../../ui/side-nav/core-menu-items';
import { SkootPermissions } from './skoot.permissions';

export function getSkootMenuItems(): MenuItem[] {
  return [
    // Make this invisible for now, as the dashboard is not yet ready for production.
    {
      label: 'Dashboard',
      url: '/main/skoot/dashboard',
      icon: faGaugeHigh,
      permission: SkootPermissions.DashboardView,
    },
    {
      label: 'Products',
      url: '/main/skoot/products',
      icon: faGifts,
      permission: SkootPermissions.ProductView,
    },
    {
      label: 'Subscriptions',
      url: '/main/skoot/subscriptions',
      icon: faClipboardList,
      permission: SkootPermissions.SubscriptionView,
    },
    {
      label: 'Orders',
      url: '/main/skoot/orders',
      icon: faReceipt,
      permission: SkootPermissions.OrderView,
    },
    // {
    //   label: 'Purchase Order Export',
    //   url: '/main/skoot/purchase-order-export',
    //   icon: faFileExport,
    //   permission: SkootPermissions.PurchaseOrderView,
    // },
    {
      label: 'Verification',
      url: '/main/skoot/document-verification',
      icon: faFileCircleCheck,
      permission: SkootPermissions.VerificationView,
    },
    {
      label: 'Asset Tracking',
      url: '/main/skoot/asset-tracking',
      icon: faLocationDot,
      permission: SkootPermissions.AssetTrackingView,
    },
    core.transactionsMenuItem,
    // core.exportMenuItem,
    core.entitiesMenuItem,
    core.usersMenuItem,
    core.auditMenuItem
  ];
}
